setAssetError